import classNames from 'classnames/bind';
import JobDdayBadge from 'components/recruit/JobDdayBadge';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { IJobItem } from 'types/recruit';
import { formatDeadline } from 'utils/date';
import { getJobMetaItems } from 'utils/recruit';
import styles from './JobCard.module.css';

const cx = classNames.bind(styles);

interface IJobCardProps {
  job: IJobItem;
}

function JobCard({ job }: IJobCardProps) {
  return (
    <li>
      <Link href={`/career/jobs/${job.id}`}>
        <a className={cx('card')}>
          <JobCardContent job={job} />
        </a>
      </Link>
    </li>
  );
}

interface IJobCardContentProps {
  job: IJobItem;
}

function JobCardContent({ job }: IJobCardContentProps) {
  const { t } = useTranslation('recruit-jobs');
  const { title, deadline } = job.attributes;
  const metaItems = getJobMetaItems({ attributes: job.attributes });

  return (
    <>
      <div className={cx('summary')}>
        <h3 className={cx('title')}>{title}</h3>
        <ul className={cx('meta')}>
          {metaItems.map(({ field, value }) => (
            <li key={field}>{value}</li>
          ))}
        </ul>
      </div>
      <div className={cx('deadline')}>
        {deadline && (
          <span>{t('deadline', { date: formatDeadline({ deadline }) })}</span>
        )}
        <JobDdayBadge deadline={deadline} />
      </div>
    </>
  );
}

export default JobCard;
